// JSON-LD builders shared by the React app and scripts/postbuild.js. Keep this file free of JSX and "@/" aliases.
import { SITE } from "../data/site";

const DAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
const ORG_ID = `${SITE.url}/#organization`;
const SITE_ID = `${SITE.url}/#website`;

export const abs = (path = "/") => `${SITE.url}${path === "/" ? "/" : path}`;

export const organizationLd = () => ({
  "@type": ["Organization", "ProfessionalService"],
  "@id": ORG_ID,
  name: SITE.name,
  url: `${SITE.url}/`,
  logo: { "@type": "ImageObject", url: `${SITE.url}/logo512.png`, width: 512, height: 512 },
  image: `${SITE.url}/og-image.jpg`,
  email: SITE.email,
  telephone: SITE.phones[0].label.replace(/\s/g, ""),
  slogan: SITE.tagline,
  description:
    "Digital solutions for fitness, sports, wellness and membership-based businesses: websites, custom software, CRM, membership management, booking systems, mobile apps, e-commerce, automation and digital marketing.",
  areaServed: "Worldwide",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Office No. 69, Ratan Colony, New Jail Road, Huzur",
    addressLocality: "Bhopal",
    addressRegion: "Madhya Pradesh",
    postalCode: "462038",
    addressCountry: "IN",
  },
  contactPoint: SITE.phones.map((p) => ({
    "@type": "ContactPoint",
    telephone: p.label.replace(/\s/g, ""),
    contactType: "customer service",
    email: SITE.email,
    availableLanguage: ["English", "Hindi"],
  })),
  ...(SITE.hours.open24x7
    ? { openingHoursSpecification: { "@type": "OpeningHoursSpecification", dayOfWeek: DAYS, opens: "00:00", closes: "23:59" } }
    : {}),
});

export const websiteLd = () => ({
  "@type": "WebSite",
  "@id": SITE_ID,
  url: `${SITE.url}/`,
  name: SITE.name,
  inLanguage: "en",
  publisher: { "@id": ORG_ID },
});

export const siteGraph = () => ({ "@context": "https://schema.org", "@graph": [organizationLd(), websiteLd()] });

export const breadcrumbLd = (crumbs) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: crumbs.map((c, i) => ({ "@type": "ListItem", position: i + 1, name: c.name, item: abs(c.path) })),
});

/** type: WebPage | AboutPage | ContactPage | CollectionPage */
export const webPageLd = ({ type = "WebPage", name, description, path }) => ({
  "@context": "https://schema.org",
  "@type": type,
  "@id": `${abs(path)}#webpage`,
  url: abs(path),
  name,
  description,
  inLanguage: "en",
  isPartOf: { "@id": SITE_ID },
  about: { "@id": ORG_ID },
});

export const itemListLd = ({ name, path, items }) => ({
  "@context": "https://schema.org",
  "@type": "ItemList",
  name,
  url: abs(path),
  numberOfItems: items.length,
  itemListElement: items.map((it, i) => ({ "@type": "ListItem", position: i + 1, name: it.name, url: abs(it.path) })),
});

export const serviceLd = ({ name, description, path }) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  "@id": `${abs(path)}#service`,
  name,
  serviceType: name,
  description,
  url: abs(path),
  areaServed: "Worldwide",
  provider: { "@id": ORG_ID },
});

export const faqLd = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
});
